import {Component, ElementRef, ViewChild} from '@angular/core';
import {MatSelect} from '@angular/material/select';
import {MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Feedback} from '@backend/modules/@users/models/feedback.model';
import {environment} from '../../../../environments/environment';
import {TorchFeedbackService} from '@backend/modules/@users/services/torch-feedback.service';
import {SessionService} from '../../services/session.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {TorchUser} from '@backend/modules/@users/models/torch-user.model';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent {
  @ViewChild(MatSelect) selectCategory: MatSelect;
  @ViewChild('summary') inputSummary: ElementRef;

  isLoading = new BehaviorSubject<boolean>(true);
  torchUser: Observable<TorchUser>;
  description: string;
  screenshotURL: string;
  feedback: Feedback;
  feedbackForm: FormGroup;
  feedbackTypes = TorchFeedbackService.feedbackTypes;

  constructor(public dialogRef: MatDialogRef<FeedbackDialogComponent>,
              private formBuilder: FormBuilder,
              private feedbackService: TorchFeedbackService,
              private sessionService: SessionService) {


    this.torchUser = this.sessionService.currentTorchUser;
    this.feedbackService.currentScreenshot.subscribe(raw => {
      if (!!raw) {
        this.screenshotURL = raw;
      }
    });

    this.torchUser.subscribe(torchUser => {
      this.feedback = Feedback.createWithUser(torchUser);

      this.feedbackForm = this.formBuilder.group({
        title: [this.feedback.title],
        type: [this.feedback.type],
        description: [this.feedback.description],
      });
    });
  }

  cancel() {
    this.parseForm();
    return this.dialogRef.close({
      action: 'cancel',
      feedback: this.feedback
    });
  }

  submit() {
    this.parseForm();
    return this.dialogRef.close({
      action: 'submit',
      feedback: this.feedback
    });
  }

  descriptionChanged(event: { event; editor }) {
    this.description = event.editor.getContent({format: 'text'}).trim();
  }

  get formInvalid() {
    return this.feedbackForm.invalid || !!!this.description || (!!this.description && this.description.length === 0);
  }

  get tinyAPIKey() {
    return environment.tinyAPIKey;
  }

  get tinySettings() {
    return {
      icons: 'material',
      skin: 'borderless',
      menubar: false,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      min_height: 350,
      // eslint-disable-next-line @typescript-eslint/naming-convention
    };
  }

  onEditorInit() {
    this.isLoading.next(false);
  }

  private parseForm() {
    const descriptionControl = this.feedbackForm.controls.description;
    const typeControl = this.feedbackForm.controls.type;
    const titleControl = this.feedbackForm.controls.title;

    this.feedback.type = typeControl.value;
    this.feedback.description = descriptionControl.value;
    this.feedback.title = titleControl.value;
    this.feedback.screenshot = this.screenshotURL.split('/').pop();
  }
}
